module.exports = __webpack_public_path__ + "static/img/storeentry__icon.786c8fbd.svg";